(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bl-ab-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bl-ab-tabs')) {
  customElements.define('bl-ab-tabs', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.bar = this.querySelector('.bl-ab-tabs__bar');
      this.track = this.querySelector('.bl-ab-tabs__track');
      this.anchors = Array.from(this.querySelectorAll('a[href^="#"]'));
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      window.addEventListener('scroll', this.schedule, {passive:true, signal:this.controller.signal});
      window.addEventListener('resize', this.schedule, {passive:true, signal:this.controller.signal});
      window.addEventListener('load', this.schedule, {signal:this.controller.signal});
      this.addEventListener('click', event => this.navigate(event), {capture:true, signal:this.controller.signal});
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.bar);
      this.observer.observe(document.body);
      this.schedule();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    headerOffset() {
      let bottom = 0;
      document.querySelectorAll(this.dataset.headerSelector).forEach(element => {
        const style = getComputedStyle(element);
        const box = element.getBoundingClientRect();
        if (style.visibility === 'hidden' || style.display === 'none' || Number(style.opacity) === 0) return;
        if ((style.position === 'fixed' || style.position === 'sticky') && box.top <= 2 && box.bottom > 0 && box.height < innerHeight / 2) bottom = Math.max(bottom, box.bottom);
      });
      return bottom;
    }
    target(anchor) {
      try { return document.getElementById(decodeURIComponent(anchor.hash.slice(1))); } catch (_) { return null; }
    }
    update() {
      const rect = this.getBoundingClientRect();
      const top = this.headerOffset();
      const height = this.bar.getBoundingClientRect().height;
      const items = this.anchors.map(anchor => ({anchor, target:this.target(anchor)})).filter(item => item.target);
      if (!items.length) return;
      this.style.setProperty('--bl-tabs-top', `${top}px`);
      this.style.setProperty('--bl-tabs-left', `${rect.left}px`);
      this.style.setProperty('--bl-tabs-width', `${rect.width}px`);
      this.style.height = `${height}px`;
      const end = document.querySelector(this.dataset.endSelector) || items[items.length - 1].target;
      const past = end.getBoundingClientRect().bottom <= top + height;
      this.classList.toggle('is-fixed', rect.top <= top);
      this.classList.toggle('is-past', past);
      let selected = items[0].anchor;
      for (const item of items) {
        if (item.target.getBoundingClientRect().top <= top + height + 40) selected = item.anchor;
      }
      this.select(selected);
    }
    select(selected) {
      if (selected === this.selected) return;
      this.selected = selected;
      this.anchors.forEach(anchor => anchor === selected ? anchor.setAttribute('aria-current','location') : anchor.removeAttribute('aria-current'));
      const box = selected.getBoundingClientRect();
      const trackBox = this.track.getBoundingClientRect();
      if (box.left < trackBox.left || box.right > trackBox.right) {
        this.track.scrollBy({left:box.left - trackBox.left - (trackBox.width - box.width) / 2, behavior:'auto'});
      }
    }
    navigate(event) {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor || !this.contains(anchor) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      const target = this.target(anchor);
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      this.select(anchor);
      history.replaceState(null, '', anchor.hash);
      const top = scrollY + target.getBoundingClientRect().top - this.headerOffset() - this.bar.getBoundingClientRect().height - 16;
      window.scrollTo({top:Math.max(0,top), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
